/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}div.outerwrap[_ngcontent-%COMP%]{height:100%}.filter[_ngcontent-%COMP%]{width:100%}.scroll[_ngcontent-%COMP%]{overflow-y:auto}.centered[_ngcontent-%COMP%]{text-align:center}.error[_ngcontent-%COMP%]{color:red}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/services/dialogs/studentsearch/studentsearch.dialogcomponent.css.shim.ngstyle.js.pre-build-optimizer.js